import React from 'react';
import PropTypes from 'prop-types';
import { getTranslation } from '../../../providers/TranslationProvider';
import Dropdown from '../../Dropdown';

const BLANK_CITY_CODE = 'blank';

const PrimaryLocationsDropdown = (props) => {
  const {
    name, selected, locations, onChange,
  } = props;
  const blankOption = {
    key: BLANK_CITY_CODE,
    value: BLANK_CITY_CODE,
    label: getTranslation({ translationKey: 'select_city', fallback: 'Select a City' }),
  };
  const locationOptions = locations.map((city) => ({
    key: city.code,
    value: city.code,
    label: city.name,
  }));
  const allOptions = [blankOption].concat(locationOptions);
  return (
    <Dropdown
      name={name}
      options={allOptions}
      selected={selected || BLANK_CITY_CODE}
      onChange={({ [name]: cityCode }) => {
        const newPrimary = (cityCode === BLANK_CITY_CODE) ? null : cityCode;
        if (onChange) {
          onChange({ primary: newPrimary });
        }
      }}
    />
  );
};

PrimaryLocationsDropdown.propTypes = {
  name: PropTypes.string.isRequired,
  selected: PropTypes.string,
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  onChange: PropTypes.func,
};

PrimaryLocationsDropdown.defaultProps = {
  selected: null,
  onChange: () => {},
};

export default PrimaryLocationsDropdown;
